import { getCookie, setCookie } from '../../scripts/utils';

const alertClass = 'c-alert';
const alertOpenClass = alertClass + '--open';

const alertJsClass = 'js-alert';
const buttonCloseJsClass = alertJsClass + '-button-close';

const alertElement = document.querySelector('.' + alertJsClass) as HTMLElement;
const buttonCloseElement = document.querySelector('.' + buttonCloseJsClass) as HTMLElement;

if (alertElement && buttonCloseElement) {
    // Get the key from the data attribute
    const key = alertElement.dataset.alertId;

    // Get cookie to se if it exists
    const cookie = getCookie(key);

    // If the cookie doesn't exist yet the alert needs to be shown
    if (!cookie) {
        // Show the alert
        alertElement.classList.add(alertOpenClass);

        // Add a click event listener on the close button
        buttonCloseElement.addEventListener('click', () => {
            // If the alert is open
            if (alertElement.classList.contains(alertOpenClass)) {
                // Hide the alert
                alertElement.classList.remove(alertOpenClass);

                // Update the inert property to prevent focus
                alertElement.inert = false;

                // Set the cookie to expire in a year
                if (key) {
                    setCookie(key, 'closed', 365);
                }
            }
        });
    }
}